export enum UserRole {
	WITHOUT_ROLE = "",
	ADMIN = "admin",
	CAJA = "caja",
	MESA = "mesa",
	COCINA = "cocina",
}
